import { Link } from 'react-router-dom';
import { useFinanceMetrics, useGlobal } from '../state';
import { LeftNav } from '../components/nav';
import { Finances } from '../components/metrics';
import { styles } from '../constants';

export default function CostExplorerPage() {
  const { apiKey } = useGlobal();
  const finances = useFinanceMetrics(apiKey);

  return (
    <LeftNav>
      <h2>Cost Explorer</h2>
      <Finances apiKey={apiKey} />
    </LeftNav>
  );
}
